import React from "react";
import { getShortestSku } from "../../utility";

const AddEditInventoryModalProductInfo = (props) => {
  const { priceChartingProductInfo, isEdit = false } = props;
  const productDataObject = priceChartingProductInfo.productMetaData
    ? priceChartingProductInfo.productMetaData
    : priceChartingProductInfo;

  return (
    <div className="d-flex flex-column gap-2 align-items-start product-content-wrapper">
      <span>{productDataObject.productName || "Product Name"}</span>
      <span>{productDataObject.consoleName || "Console Name"}</span>
      <span>{productDataObject.subcategory || "Subcategory"}</span>
      <span>
        {productDataObject?.skuNumber?.length
          ? `#${getShortestSku(productDataObject?.skuNumber)}`
          : "#Auto Generated"}
      </span>
      {/* <span>{`In Stock: ${
        isEdit
          ? productDataObject.inStoreQuantity || 0
          : productDataObject.inStockQuantity
      }`}</span> */}
    </div>
  );
};

export default AddEditInventoryModalProductInfo;
